export default {
  layoutSelectors: ["#billing-phone"],
  inputIdentifier: "#billing-phone",
  countryIdentifier: "#components-form-token-input-0",
  label: "block billing checkout (phone)"
}
